import React, { createContext, useContext, useState, useEffect } from 'react';

const PageTitleContext = createContext({ titulo: null, setTitulo: () => {} });

export function PageTitleProvider({ children }) {
  const [titulo, setTitulo] = useState(null);
  return (
    <PageTitleContext.Provider value={{ titulo, setTitulo }}>
      {children}
    </PageTitleContext.Provider>
  );
}

export function usePageTitleContext() {
  return useContext(PageTitleContext);
}

// Telas de formulário chamam isso pra sobrescrever o título fixo do TopBar (que
// por padrão vem do item do menu) com algo específico, tipo "Novo Produto" ou
// "Produto 5 - Parafuso". Ao desmontar, volta pro título padrão da página.
export function useTituloPagina(titulo) {
  const { setTitulo } = usePageTitleContext();
  useEffect(() => {
    setTitulo(titulo);
    return () => setTitulo(null);
  }, [titulo]); // eslint-disable-line
}
